export default __webpack_public_path__ + "static/media/unavailable.4c0cc9e5.svg";